<div class="popup-wrap2"
     (click)="onVoid($event)">
  <article class="popup-connect-box">
    <div class="connect-body linked-example-connect-body">
      <div class="head-box"
           *ngIf="exampleSJ">
        <app-example-disp [exampleSJ]="exampleSJ"></app-example-disp>
        <button type="button"
                *ngIf="hasVoice"
                class="linked-example-play-btn {{ on ? 'on' : '' }}"
                [attr.aria-label]="on ? '예문 소리 정지' : '예문 소리 듣기'"
                (click)="playSound($event)"></button>
      </div>
    </div>

    <div class="connect-tail">
      <div class="more-link-btn-box">
        <a class="more-link-btn"
           (click)="onClickDetail($event)">자세히 보기</a>
      </div>

      <div class="menu-box">
        <a class="close-btn"
           (click)="onClose($event)"></a>
      </div>
    </div>
  </article>
</div>
